var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaused = function SvgPaused(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 0H13.5L20.5 4V20H7.5L0.5 16V0Z",
    fill: "#A4A4A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 6C6.72386 6 6.5 6.22386 6.5 6.5V13.5C6.5 13.7761 6.72386 14 7 14H9.5C9.77614 14 10 13.7761 10 13.5V6.5C10 6.22386 9.77614 6 9.5 6H7ZM7.5 13V7H9V13H7.5Z",
    fill: "#1B1B1B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 6C11.2239 6 11 6.22386 11 6.5V13.5C11 13.7761 11.2239 14 11.5 14H14C14.2761 14 14.5 13.7761 14.5 13.5V6.5C14.5 6.22386 14.2761 6 14 6H11.5ZM12 13V7H13.5V13H12Z",
    fill: "#1B1B1B"
  })));
};
export { SvgPaused as ReactComponent };
export default __webpack_public_path__ + "assets/b945a4a1.svg";